const styles = () => ({
  accordion: {
    boxShadow: 'none',
    margin: 0,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&.Mui-expanded': {
      margin: '8px 0',
    },
    '&:before': {
      display: 'none',
    },
    borderRadius: 0,
  },
  accordionSummary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '24px 0',
    '@media(max-width: 767px)': {
      padding: '16px 0px',
    },
  },
  accordionDetails: {
    padding: 0,
    paddingLeft: 24,
    display: 'flex',
    flexDirection: 'column',
  },
});

export default styles;
